import { CSSProperties, ReactNode } from 'react';

import './header-filter-panel.scss';

interface HeaderFilterPanelProps {
	children: ReactNode;
	actions?: ReactNode;
	className?: string;
	fieldsClassName?: string;
	columnsTemplate?: string;
}

export function HeaderFilterPanel({
	children,
	actions,
	className,
	fieldsClassName,
	columnsTemplate = 'minmax(320px, 1.8fr) minmax(180px, 0.7fr)',
}: Readonly<HeaderFilterPanelProps>) {
	const fieldsStyle: CSSProperties = {
		gridTemplateColumns: actions ? `${columnsTemplate} auto` : columnsTemplate,
	};

	return (
		<div className={`header-filter-panel ${className ?? ''}`.trim()}>
			<div className={`header-filter-panel__fields ${fieldsClassName ?? ''}`.trim()} style={fieldsStyle}>
				{children}
				{actions ? <div className="header-filter-panel__actions">{actions}</div> : null}
			</div>
		</div>
	);
}
